import React, { Component, useState } from "react";
import { render } from "react-dom";
import JuryBases from "./JuryBasesMobile";
import JuryBasesD from "./JuryBasesDesktop";
import { useMediaQuery } from 'react-responsive'


export default function AdminBasesResponsive(){
    const isMobileDevice = useMediaQuery({
        query: "(max-width: 48em)",
      });

  return(
      <div>
        {!isMobileDevice && <JuryBasesD/>}
        {isMobileDevice && <JuryBases/>}  
      </div>
    )
}

